export default __webpack_public_path__ + "static/media/program_intro_2.8719fce9.png";